module.exports = __webpack_public_path__ + "static/media/starProduct2.7c44612f.png";